import { render } from "./ResultExplanation.vue?vue&type=template&id=2b47db72"
import script from "./ResultExplanation.vue?vue&type=script&lang=js"
export * from "./ResultExplanation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__